"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorUnderlineIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7 7a1 1 0 1 1 2 0v4c0 1.884.93 3 3 3s3-1.116 3-3V7a1 1 0 0 1 2 0v4c0 2.916-1.737 5-5 5s-5-2.084-5-5zm0 10h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2"/></svg>`
}, props));
EditorUnderlineIcon.displayName = 'EditorUnderlineIcon';
var _default = exports.default = EditorUnderlineIcon;